import {  Alert} from '../../types';
import { updateAlert } from '../api';

export const processAllAlerts = (alerts: Alert[], monitorId: number, updateState: any, clearedState: boolean) => {
  const clearAlerts = alerts.map((alert) => {
    alert.cleared = clearedState;
    const alertToUpdate = { monitorId, alert,};
    updateState(alertToUpdate);
    updateAlert(alert);
    return alert;
  })
  return clearAlerts;
}






// WEBPACK FOOTER //
// ./src/utils/alerts/processAllAlerts.ts